// import { useEffect } from 'react';
import { BrowserRouter, useHistory } from 'react-router-dom';

import AppRouting from "./App-routing";
import Alert from "./components/UI/alert";
import ErrorBoundary from './ErrorBoundary';

function App() {


  const history = useHistory()

  // console.log("Hello akash")

  return (
    <>
      <BrowserRouter basename="/" history={history}>
        <ErrorBoundary>
          <AppRouting />
          <Alert />
        </ErrorBoundary>
      </BrowserRouter>

    </>
  );
}

export default App;
